import { Request, RequestStatus } from "@/types/request";

const REQUEST_STATUSES_WITHOUT_DELAY_ALERT = new Set<RequestStatus>([
  RequestStatus.CANCELED,
  RequestStatus.COMPLETED,
  RequestStatus.DONE,
  RequestStatus.ON_HOLD,
]);

export function getRequestTaskStatus(request: Request): RequestStatus {
  return request.tasks?.[0]?.status ?? request.status ?? RequestStatus.NEW_TASK;
}

export function isRequestOverdue(
  request: Request,
  now: Date = new Date(),
): boolean {
  if (!request.dueDateTime) {
    return false;
  }

  const dueDate = new Date(request.dueDateTime);

  if (Number.isNaN(dueDate.getTime())) {
    return false;
  }

  const status = getRequestTaskStatus(request);

  return (
    dueDate.getTime() < now.getTime() &&
    !REQUEST_STATUSES_WITHOUT_DELAY_ALERT.has(status)
  );
}
